export default __webpack_public_path__ + "static/media/arrow_left.59c869a3.svg";